import React from 'react';
import PropTypes from 'prop-types';
import LoadErrorMessage from './LoadErrorMessage';
import { cacheStatusTypes } from '../../actions/CacheStatusActions';
import LoadProgress from './LoadProgress';
import StartTestComponentButton from './StartTestComponentButton';
import testComponentService from '../../services/TestComponentService';
import readinessCheckService from '../../services/ReadinessCheckService';

const TestComponentReadinessCheck = ({ cacheStatus, title, readinessCheckContentRevisionId, shouldCacheResources }) => {
    if (shouldCacheResources) {
        if (testComponentService.testResourcesIncompletelyCached(cacheStatus, shouldCacheResources)) {
            return <LoadErrorMessage cacheStatus={cacheStatus} />;
        }
        if (cacheStatus.status !== cacheStatusTypes.DONE) {
            return <LoadProgress id={readinessCheckContentRevisionId} notifyOnTimeout={false} cacheStatus={cacheStatus} />;
        }
    }

    const startReadinessCheckAction = () => {
        readinessCheckService.startReadinessCheckAndNavigate(readinessCheckContentRevisionId);
    };

    return (
        <StartTestComponentButton
            passwordCorrect
            title={title}
            startComponentAction={startReadinessCheckAction}
        />
    );
};

TestComponentReadinessCheck.propTypes = {
    readinessCheckContentRevisionId: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    cacheStatus: PropTypes.object.isRequired,
    shouldCacheResources: PropTypes.bool.isRequired,
};

export default TestComponentReadinessCheck;
